/* eslint-disable max-classes-per-file */

import { UpdateSealedSegmentAction } from './real-time-sealing.actions'

export class SealingMarkerUpdateFailedEvent {
  static readonly type = '[RealTimeSealing] Sealing Marker Update Failed'

  constructor(
    readonly command: UpdateSealedSegmentAction,
    readonly reason: string,
    readonly isResettable: boolean,
    readonly isRetryable: boolean,
  ) {}
}

export class SealingMarkerUpdateSucceededEvent {
  static readonly type = '[RealTimeSealing] Sealing Marker Update Succeeded'

  constructor(readonly command: UpdateSealedSegmentAction) {}
}
